import { Form, Modal, Select } from "antd";
import { useTranslation } from "react-i18next";
import { useEffect, useMemo, useState } from "react";
import { ModalHeader } from "datastake-daf/dist/components";
import AmpService from "../../../../services/AmpService";

export default function EditStatusModal({
  amp,
  status = '',
  visible = false,
  onClose = () => { },
  onFinish = () => { },
}) {
  const { t } = useTranslation();
  const [value, setValue] = useState(status);
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    if (loading) {
      return;
    }

    setLoading(true);

    try {
      await AmpService.changeStatusApplication({
        ...amp,
        status: value,
      });

      onClose();
      onFinish();
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  };

  const options = useMemo(() => [
    { label: t('Application'), value: 'application' },
    { label: t('Assessment'), value: 'assessment' },
    { label: t('Declined'), value: 'declined' },
  ], [t]);

  useEffect(() => {
    setValue(status);
  }, [visible, status]);

  return (
    <Modal
      open={visible}
      title={<ModalHeader title={t('Edit Status')} />}
      cancelText={t('Cancel')}
      okText={t('Save')}
      onOk={onSubmit}
      onCancel={onClose}
    >
      <Form layout="vertical">
        <Form.Item label={t('Status')}>
          <Select
            options={options}
            value={value}
            onChange={(val) => setValue(val)}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
